import { render } from "./payroll-table.vue?vue&type=template&id=8425d264&scoped=true"
import script from "./payroll-table.vue?vue&type=script&lang=js"
export * from "./payroll-table.vue?vue&type=script&lang=js"

import "./payroll-table.vue?vue&type=style&index=0&id=8425d264&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8425d264"]])

export default __exports__